// extracted by css-extract-rspack-plugin
var _1 = "BCFtC0B9GB-XJ05rtqCqLw--";
var _2 = "MBeQ1ELoizYjx65U-eJiEQ--";
export { _1 as "closeButton", _2 as "content" }
